<template>
	<div class="content my-0 py-1">
		<div class="container-fluid">
			<div class="row">
				<div class="col-12  mt-2 py-0">
					<h4 class="m-0 p-0 text-secondary d-inline">Harga Perangkat</h4>
					<button class="float-right btn btn-primary shadow mt-2"
					        v-on:click="formHardwarePriceActive=!formHardwarePriceActive">Tambah Harga Perangkat Baru
					</button>
				</div>
				<transition name="fade">
					<div class="col-12  my-2 py-0" v-if="formHardwarePriceActive">
						<div class="row p-3 mx-2 bg-white shadow">
							<div class="col-12 mb-3">
								<h4 class="my-0 py-0">Form Harga Perangkat Baru</h4>
								<hr>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">Nama Paket Perangkat <span style="color:red;">*</span></label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="newHardwarePrice.name_hardware_price"/>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">Harga <span style="color:red;">*</span></label>
								<input type="number" class="form-control w-100 rounded"
								       v-model="newHardwarePrice.price"/>
							</div>

							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start"
								     v-if="newHardwarePriceSaved">
									<div class="alert alert-success" role="alert">
										Berhasil Menyimpan Harga Perangkat Baru.
									</div>
								</div>
							</div>

							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start"
								     v-if="errorNewHardwarePrice">
									<div class="alert alert-danger" role="alert">
										<div class="my-0">
											<p class="d-block mt-1">Gagal Menyimpan Harga Perangkat Baru.</p>
										</div>
										<div v-for="err in errorHardwarePriceList" v-bind:key="err" class="my-0">
											<p v-for="note in err" v-bind:key="note" class="d-block mt-1">{{ note }}</p>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 mt-3">
								<div class="d-flex align-items-center justify-content-start"
								     v-if="savingNewHardwarePrice">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
								</div>
								<button class="btn btn-primary float-right" type="button"
								        v-on:click="saveNewHardwarePrice">Submit
								</button>
							</div>
						</div>
					</div>
				</transition>


				<div class="col-12  my-2 py-0">
						<datatable :currentIdx="currentPage" :datas="hardwareprices" :structure="hardwarepriceTableStructure" :init="loadData"
						           :next-url="nextUrl" :prev-url="prevUrl" @change-page="(isNext)=>{changePage(isNext)}"
						           use-seeker seeker-url="/api/master/seeker/hardware-price"
						           @refetch="(row)=>{rowLimit=row;getHardwarePrices()}"
						           @searching="(val)=>!val.status?getHardwarePrices():hardwareprices=val.data">
						<template #customcell={obj,index}>
							<td v-if="isMobile" class="py-3">
								<ul style="list-style:none;width:100%;padding:0" class="rounded shadow bg-white p-2">
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Nama paket perangkat:</small>
											<br><b class="py-0 mx-0" style="font-size:10pt">{{
												obj.name_hardware_price
											}}</b>
										</div>
										<hr class="my-1">
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Harga:</small>
											<br><b class="py-0 mx-0" style="font-size:10pt">Rp
											{{ obj.price | numeral("0,0") }}</b>
										</div>
										<hr class="my-1">
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<b-button v-b-modal.modal-edit-hardwareprice class="btn btn-info mr-2"
											          v-on:click="selectedIdforEdit=index;dataEdit=Object.assign({},obj)">
												<b-icon icon="pencil-square"></b-icon>
											</b-button>
											<b-button v-b-modal.modal-delete
											          v-on:click="deleteId=obj.id;itemToDelete=obj"
											          class="btn btn-danger">
												<b-icon icon="trash"></b-icon>
											</b-button>
										</div>
									</li>
								</ul>
							</td>
							<td v-if="!isMobile">{{ ((currentPage - 1) * perPage) + index + 1 }}</td>
							<td v-if="!isMobile">{{ obj.name_hardware_price }}</td>
							<td v-if="!isMobile">Rp{{ obj.price | numeral("0,0") }}</td>
							<td v-if="!isMobile">
								<b-button v-b-modal.modal-edit-hardwareprice class="btn btn-info mr-2"
								          v-on:click="selectedIdforEdit=index;dataEdit=Object.assign({},obj)">
									<b-icon icon="pencil-square"></b-icon>
								</b-button>
								<b-button v-b-modal.modal-delete v-on:click="deleteId=obj.id;itemToDelete=obj"
								          class="btn btn-danger">
									<b-icon icon="trash"></b-icon>
								</b-button>
							</td>
						</template>
					</datatable>
				</div>

				<b-modal id="modal-edit-hardwareprice" title="Edit data" no-close-on-backdrop size="lg"
				         @hide="editModalClose">
					<div class="row" v-if="hardwareprices[selectedIdforEdit]!=undefined">
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">Nama Paket Perangkat</label>
							<input type="text" class="form-control w-100 rounded"
							       v-model="hardwareprices[selectedIdforEdit].name_hardware_price"/>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">Harga</label>
							<input type="number" class="form-control w-100 rounded"
							       v-model="hardwareprices[selectedIdforEdit].price"/>
						</div>

						<div class="col-12 mt-3">
							<div class="w-100 align-items-center justify-content-start" v-if="updateSaved">
								<div class="alert alert-success" role="alert">
									Berhasil Update Data Harga Perangkat.
								</div>
							</div>
						</div>
					</div>
					<template #modal-footer>
						<div class="w-100 text-right m-0 p-0">
							<hr>
							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start" v-if="errorUpdate">
									<div class="alert alert-danger" role="alert">
										<div class="my-0">
											<p class="d-block mt-1 text-left">Gagal update Harga Perangkat.</p>
										</div>
										<div v-for="err in errorHardwarePriceList" v-bind:key="err" class="my-0">
											<p v-for="note in err" v-bind:key="note" class="d-block mt-1">{{ note }}</p>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 mt-3">
								<div class="d-flex align-items-center justify-content-start" v-if="updating">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
								</div>
								<button class="btn btn-info float-right" type="button" v-on:click="updateHardwarePrice">
									Submit
								</button>
								<b-button class="btn btn-secondary mr-2"
								          @click="$bvModal.hide('modal-edit-hardwareprice')">Tutup
								</b-button>
							</div>
						</div>
					</template>
				</b-modal>

				<modal-delete url="/api/master/hardware-price/" @read="()=>{console.log('modal ready')}"
				              @result="deleteResult" :targetid="deleteId">
					Yakin mau menghapus data dengan detail berikut :<br>
					<ul>
						<li>Perangkat: {{ itemToDelete.name_hardware_price }}</li>
						<li>Harga: Rp.{{ itemToDelete.price | numeral("0,0") }}</li>
					</ul>
				</modal-delete>

				<!-- <b-modal no-close-on-esc  content-class="m-0"  id="modal-delete-po" title="Konfirmasi hapus data" scrollable no-close-on-backdrop @hide="deleteModalClose">
					<b-container fluid v-if="!loadData">
						<b-row class="pt-1">
						<b-col cols="12" class="my-3">
							<h4>Apakah yakin mau menghapus data dengan detail berikut:</h4>
							<ul v-if="hardwareprices.length>0">
								<li>Harga Perangkat: {{hardwareprices[selectedToDelete].name_hardware_price}}</li>
								<li>Harga: {{hardwareprices[selectedToDelete].price}}</li>
							</ul>
						</b-col>
						<b-col cols="12" class="my-3 text-right"  v-if="deleteState">
							<div class="d-flex align-items-center justify-content-start">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menghapus data, tunggu sebentar.</strong>
								</div>
							</b-col>
							<div class="col-12 mt-3"  v-if="deleted">
								<div class="w-100 align-items-center justify-content-start">
									<div class="alert alert-success" role="alert">
										Berhasil menghapus data hardware price.
									</div>
								</div>
							</div>
							<div class="col-12 mt-3"  v-if="deleteFail">
								<div class="w-100 align-items-center justify-content-start">
									<div class="alert alert-danger" role="alert">
										Gagal menghapus data hardware price.
									</div>
								</div>
							</div>
						</b-row>
					</b-container>
					<template #modal-footer>
						<div class="w-100 text-right m-0 p-0">
						<hr>
						<button class="btn btn-danger mr-2" v-on:click="deleteData">Ya, hapus</button>
						<b-button class="btn btn-secondary" @click="(!deleteState)?$bvModal.hide('modal-delete-po'):''">Tutup</b-button>
						</div>
					</template>
				</b-modal> -->

			</div>
		</div>
	</div>
</template>
<script>
//   import ChartCard from 'src/components/Cards/ChartCard.vue'
//   import StatsCard from 'src/components/Cards/StatsCard.vue'
//   import LTable from 'src/components/Table.vue'
import * as axios from "axios";
import Datatable from "../../components/Datatable.vue";
import SmartSelect from "../../components/SmartSelect.vue";
import SmartSearch from "../../components/SmartSearch.vue";
import ModalDelete from "../../components/ModalDelete.vue";

export default {
	components: {
		//   LTable,
		//   ChartCard,
		//   StatsCard
		"datatable": Datatable,
		"smart-select": SmartSelect,
		"smart-search": SmartSearch,
		"modal-delete": ModalDelete
	},
	data() {
		return {
			currentPage: 1,
			perPage: null,
			rowLimit: 10,
			nextUrl: null,
			prevUrl: null,
			isMobile: false,
			//step 1 edit
			dataEdit: null,
			itemToDelete: {},
			deleteId: 0,
			hardwareprices: [],
			searchValue: "",
			loadData: true,
			savingNewHardwarePrice: false,
			updating: false,
			updateSaved: false,
			deleted: false,
			deleteFail: false,
			deleteState: false,
			selectedToDelete: 0,
			errorNewHardwarePrice: false,
			errorUpdate: false,
			errorHardwarePriceList: [],
			newHardwarePriceSaved: false,
			selectedIdforEdit: 0,
			selectedTab: 0,
			newHardwarePrice: {
				name_hardware_price: "",
				price: ""

			},
			formHardwarePriceActive: false,
			hardwarepriceTableStructure: [
				//label: nama heading, key: nama object property
				{label: "No", key: null},
				{label: "Nama Paket Perangkat", key: null},
				{label: "Harga", key: null},
				{label: "Tindakan", key: null}
			]
		};
	},
	created() {
		console.clear();
		this.$reActivateAccess(this); /*SETTIMEOUT LOGOUT OTOMATIS, (this,true) UTK MELIHAT DETIK DI BROWSHER*/
		console.log("user page");
		this.getHardwarePrices();
		this.isMobile = this.$isMobile;
		window.addEventListener("resize", () => {
			console.log("screen update");
			this.isMobile = screen.width < 768;
		});
		// var newData = [];
		// for(var x=0;x<100;x++){
		//     newData.push({id:x,name:'nama_'+x,username:'nama'+x,role:'user'});
		// }
		// console.log(newData);
		// this.users = newData;
	},
	methods: {
		changePage(isNext) {
			var url = (isNext ? this.nextUrl : this.prevUrl);
			let params = (new URL(url)).searchParams;
			const myParams = params.get("page");
			this.currentPage = parseInt(myParams);
			var newUrl = this.$baseUrl + "/api/master/hardware-price?limit=" + this.rowLimit + "&page=" + myParams;
			this.getHardwarePrices(newUrl);
		},
		deleteResult(deleted) {
			console.log(deleted);
			if (deleted) {
				this.getHardwarePrices();
			}
		},
		getHardwarePrices(url = (this.$baseUrl + "/api/master/hardware-price?limit=" + this.rowLimit)) {
			this.loadData = true;
			axios.get(url, {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				console.log(result);
				this.prevUrl = result.data.prev_page_url;
				this.nextUrl = result.data.next_page_url;
				this.currentPage = result.data.current_page;
				this.perPage = parseInt(result.data.per_page);
				this.hardwareprices = result.data.data;
				this.loadData = false;
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err);
				this.loadData = false;
			});
		},
		updateHardwarePrice() {
			this.updating = true;
			this.errorUpdate = false;
			axios.put(
				this.$baseUrl + "/api/master/hardware-price/" + this.hardwareprices[this.selectedIdforEdit].id,
				this.hardwareprices[this.selectedIdforEdit],
				{
					headers: {"Authorization": "Bearer " + localStorage.getItem("accessToken")}
				}
			).then((result) => {
				if (result.status = 200) {
					this.updating = false;
					this.updateSaved = true;
					//step 4 edit
					this.dataEdit = this.hardwareprices[this.selectedIdforEdit];
					setTimeout(() => {
						this.updateSaved = false;
						this.$bvModal.hide("modal-edit-hardwareprice");
					}, 1000);
				}
				console.log(result);
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				this.updating = false;
				this.errorUpdate = true;
				console.log(err.response);
			});
		},
		updateNewPoPPN(data) {
			this.newPurchaseOrder.ppn = data;
		},
		// saveNewPurchaseOrder(){
		//     this.savingNewAirtimePrice=true
		//     this.errorNewAirtimePrice=false
		//     console.log(this.newPurchaseOrder)
		//     if(this.newPurchaseOrder.name_airtime_price!='' && this.newPurchaseOrder.price){
		//         axios.post(this.$baseUrl+'/api/master/airtimeprice',
		//         {
		//             name_airtime_price:this.newPurchaseOrder.name_airtime_price,
		//             price:this.newPurchaseOrder.price
		//         },
		//         {
		//             'headers':
		//             {
		//                 'Authorization':'Bearer '+localStorage.getItem('accessToken')
		//             }
		//         }).then((result)=>{
		//             //console.log(result)
		//             if(result.data.create){
		//                 this.getAirtimePrices();
		//             }
		//             this.newAirtimePrice.name_airtime_price='',
		//             this.newAirtimePrice.price='',
		//             this.savingNewAirtimePrice=false
		//             this.newAirtimePriceSaved=true

		//             setTimeout(() => {
		//                 this.newAirtimePriceSaved=false
		//                 this.formAirtimePriceActive=false
		//             }, 1500);

		//         }).catch((err)=>{
		//check if token fail
		//   if(err.response && err.response.status==401){
		//     localStorage.removeItem('accessToken')
		//   this.$router.push('/login')
		//   }
		//             console.log(err.response)
		//             this.errorAirtimePriceList=[]
		//             this.errorAirtimePriceList=Object.values(err.response.data.errors)
		//             console.log(this.errorAirtimePriceList)
		//             this.errorNewAirtimePrice=true
		//             this.savingNewAirtimePrice=false
		//         })
		//     }
		// },
		// deleteItem(index){
		//     console.log('button delete untuk user id: '+index)
		// },
		// updateUserRoleValue(newValue){
		//     this.newPurchaseOrder.role=newValue
		// },
		// setNewClientId(newId){
		//     this.newPurchaseOrder.clientId = newId;
		//     console.log(this.newPurchaseOrder.clientId)
		// },
		// updateNewHardwareItemType(value){
		//     this.newPurchaseOrder.itemType=value;
		// },
		// smartSearchUpdated(data,index){
		//     this.newPurchaseOrder.hardware.id[index]=data.id
		//     console.log(this.newPurchaseOrder.hardware.id[index])
		// },
		// smartSearchUpdatedVendor(data,index){
		//     this.newPurchaseOrder.vendor_id[index]=data.id
		//     console.log(this.newPurchaseOrder.vendor_id[index])
		// },
		saveNewHardwarePrice() {
			//if(this.newPurchaseOrder.no_po!=''){}
			// console.log(this.newPurchaseOrderSaved)
			// return;
			this.savingNewHardwarePrice = true;
			this.errorNewHardwarePrice = false;
			this.errorHardwarePriceList = [];
			if (this.newHardwarePrice.name_hardware_price == "") {
				this.errorHardwarePriceList.push(["- Mohon isi nama hardware"]);
			}
			if (this.newHardwarePrice.price == "") {
				this.errorHardwarePriceList.push(["- Mohon isi price"]);
			}
			console.log(this.errorHardwarePriceList);
			axios.post(this.$baseUrl + "/api/master/hardware-price", {
				           "name_hardware_price": this.newHardwarePrice.name_hardware_price,
				           "price": this.newHardwarePrice.price
			           },
			           {
				           "headers":
					           {"Authorization": "Bearer " + localStorage.getItem("accessToken")}
			           }
			).then((result) => {
				console.log(result);
				this.savingNewHardwarePrice = false;
				this.newHardwarePriceSaved = true;
				this.getHardwarePrices();
				setTimeout(() => {
					this.formHardwarePriceActive = false;
					this.newHardwarePriceSaved = false;
				}, 1500);
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err.response);
				this.errorHardwarePriceList = [];
				this.errorHardwarePriceList = Object.values(err.response.data.errors);
				console.log(this.errorHardwarePriceList);
				this.savingNewHardwarePrice = false;
				this.errorNewHardwarePrice = true;
			});
		},
		deleteModalClose() {
			console.log("test");
		},
		deleteData() {
			this.deleteState = true;
			axios.delete(
				this.$baseUrl + "/api/master/hardware-price/" + this.hardwareprices[this.selectedToDelete].id,
				{
					headers: {"Authorization": "Bearer " + localStorage.getItem("accessToken")}
				}
			)
			     .then((result) => {
				     if (result.status == 200) {
					     this.hardwareprices.splice(this.selectedToDelete, 1);
					     this.deleted = true;
					     setTimeout(() => {
						     this.deleted = false;
					     }, 1000);

				     } else {
					     this.deleteFail = true;
				     }
				     this.deleteState = false;
			     }).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err.response);
				this.deleteState = false;
				this.deleteFail = true;
			});
		},
		deleteModalClose(mdl) {
			if (this.deleteState) {
				console.log("deleting");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-delete-hardwareprice");
			}
		},
		editModalClose(mdl) {
			//step 2 edit
			this.$set(this.hardwareprices, this.selectedIdforEdit, this.dataEdit);
			//step 3 edit
			this.dataEdit = Object.assign({}, null);
			if (this.updating) {
				console.log("updating");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-edit-hardwareprice");
			}
		}

	}
};
</script>

<style scoped>
.dropdown-menu {
	display: none;
}

.btn {
	padding: 2px 6px;
}

/* MENGHILANGKAN ICON HIDE AND SHOW BAWAAN TYPE DATA */
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

/* Firefox */
input[type=number] {
	-moz-appearance: textfield;
}

</style>